// @ts-nocheck
import { isLocal } from "./devUtils";

export async function logAnalyticsEvent(event, payload = {}) {
    if (!global.posthog) {
        return;
    }

    const loc = global.location;
    const url = loc.pathname === "/" ? loc.href : loc.pathname + loc.search;

    const isDev = await isLocal();
    if (!isDev) {
        global.posthog.capture(event, { ...payload, pageURL: url });
    } else {
        // eslint-disable-next-line no-console
        console.log(`Posthog local: ${event}: ${JSON.stringify({ ...payload, pageURL: url })}`);
    }
}

export async function insertUserProperty(key, value) {
    if (!global.posthog) {
        return;
    }

    const isDev = await isLocal();
    if (!isDev) {
        global.posthog.people.set({ key: value });
    } else {
        // eslint-disable-next-line no-console
        console.log(`Posthog local: User Property ${key}: ${JSON.stringify(value)}`);
    }
}

export const sendEventToGTM = (eventName) => {
    global.dataLayer?.push({ event: eventName });
};
